import { render, staticRenderFns } from "./AndroidApp.vue?vue&type=template&id=7bbfdd85"
import script from "./AndroidApp.vue?vue&type=script&lang=js"
export * from "./AndroidApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports